module.exports = __webpack_public_path__ + "media/assets/images/btn_analysis@2x-658359c1e21beb778e6e183684cb2344.png";